type StatusOption = { value: string; label: string; disabled: boolean };

export function getStatusOptions(currentStatus: string, isPersonalDetailsValid: boolean): StatusOption[] {
  const options: StatusOption[] = [];
  if (currentStatus === 'Invited') {
    // Show Invited (disabled), Active, InActive
    options.push({ value: 'Imported', label: 'imported', disabled: false });
    options.push({ value: 'Invited', label: 'invited', disabled: false });
  } else if (currentStatus === 'Active') {
    // Only allow switch to InActive
    options.push({ value: 'Active', label: 'active', disabled: false });
    options.push({ value: 'InActive', label: 'inactive', disabled: false });
  } else if (currentStatus === 'InActive') {
    // Only allow switch to Active
    options.push({ value: 'Active', label: 'active', disabled: false });
    options.push({ value: 'InActive', label: 'inactive', disabled: false });
  } else {
    // Default: allow Draft, Active, InActive
    options.push({ value: 'Imported', label: 'imported', disabled: false });
    options.push({ value: 'Invited', label: 'invited', disabled: false });

    /* if (isPersonalDetailsValid) {
      options.push({ value: 'Invited', label: 'invited', disabled: false });
    } */
    
  }
  return options;
}